const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship Marketing en Movimiento',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Transmisión en vivo: Martes 11:00 AM por TNO Network',
      'Presencia en Web, App y Redes Sociales',
      'Asociación con marketing, emprendimiento y transformación digital',
      logoPaginaDofollow,
    ],
    idealFor: 'Agencias, SaaS, consultoras, bancos y marcas B2B que buscan audiencia de decisión en marketing y negocios.',
    duration: 'Mensual',
    buttonText: 'Patrocinar Marketing en Movimiento',
    highlightedTitle: 'Estrategia en Movimiento Multiplataforma',
    highlightedContent: [
      'Tu marca acompaña a Loyola Rosales y Luzmey Hernández.',
      'Tres menciones + un comercial de 20 segundos dentro del programa.',
      'Temas de economía, marketing real, talento y digitalización en un solo espacio.',
    ],
    highlightedButtonText: 'Ver Demo del Programa',
  },
  {
    title: 'Segmento Exclusivo por Tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Marketing Digital, Emprendimiento, Talento o Neuroventas',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas especializadas que buscan relevancia temática frente a tomadores de decisión.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Autoridad de Nicho',
    highlightedContent: [
      'Tu marca se convierte en referente del segmento elegido.',
      'Asociación orgánica con innovación, ROI y crecimiento empresarial.',
      'Ideal para posicionar servicios en contextos de alta afinidad.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Entrevista Patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de puntos de venta o contacto comercial',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'CEOs, consultores, coaches y voceros que buscan visibilidad ante audiencia de marketing y negocios.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Proyección y respaldo visual',
    highlightedContent: [
      'Proyección de videos promocionales durante la entrevista.',
      'Mención de canales de venta con respaldo visual en pantalla.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'Post Patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de Marketing en Movimiento y TNO Digest',
      'Contenido adaptado a marketing, emprendimiento y negocios',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar Post Patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed oficial de TNO Digest.',
      'Ideal para lanzamientos, webinars o reforzar una campaña B2B.',
    ],
    highlightedButtonText: 'Solicitar Post',
  },
  {
    title: 'Cápsula de Marca / Insight',
    annualPrice: 'Pack 5 Cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética del programa',
      'Distribución en redes sociales de TNO y del programa',
      'Tema: tip estratégico, lanzamiento o promoción',
      'Locución profesional en línea con el tono del show',
      logoPaginaDofollow,
    ],
    idealFor: 'Promociones de servicios, lanzamientos de producto o mensajes de autoridad en marketing.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar Cápsula',
    highlightedTitle: 'Atención en Redes',
    highlightedContent: [
      'Tu mensaje en el ecosistema de Marketing en Movimiento.',
      'Formato breve y memorable para máxima recordación.',
      'Ideal para campañas de corto plazo y alto impacto.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  {
    title: 'UGC Business Video',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video dinámico estilo testimonio o caso de uso B2B',
      'Demostración real del producto o servicio en contexto profesional',
      'Narrativa enfocada en resultados y confianza',
      'Publicación del video en TNO y en Marketing en Movimiento',
      'Entrega de archivo original para pauta publicitaria de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Software, consultoría, educación ejecutiva, fintech y servicios profesionales.',
    duration: 'Por pieza',
    buttonText: 'Activar Campaña UGC',
    highlightedTitle: 'Prueba Social Directa',
    highlightedContent: [
      'El contenido UGC genera hasta 6.9 veces más impacto que la publicidad tradicional.',
      'Tu marca se posiciona como recomendación de un aliado, no como un anuncio frío.',
    ],
    highlightedButtonText: 'Activar Campaña UGC',
  },
];

export default optionsData;
